var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.websiteFormat === 'menu_only')?_c('MenuView'):(['liquor', 'tobacco'].includes(_vm.websiteFormat))?_c('TemplateView'):(_vm.websiteFormat === 'store_info_rewards')?_c('StoreInfoRewardsView'):[(_vm.$vuetify.breakpoint.xsOnly)?_c('XsDepartments'):_c('Departments')],(
      !(_vm.storeInfo.delivery_name === 'Bringg' && _vm.order.service === 'DELIVERY')
    )?_c('OrderReceivedDialog'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }